<template>
    <div class="dashboard">
        <div class="row row-cards">
            <div v-for="(card, index) in cards" :key="index" class="col-6 col-sm-4 col-lg-3">
                <div class="card">
                    <div class="card-body p-3 text-center">
                        <a v-if="card.link" :href="card.link">
                            <div class="h1 m-0">{{ card.value }}</div>
                            <div class="text-muted mb-4">{{ card.label }}</div>
                        </a>
                        <div v-else>
                            <div class="h1 m-0">{{ card.value }}</div>
                            <div class="text-muted mb-4">{{ card.label }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import methods from '../GallerySelector/methods';

export default {
    data() {
        return {
            cards: []
        };
    },
    mounted() {
        axios
            .get('/')
            .then(r => {
                this.cards = r.data;
            })
            .catch(() => {})
            .then(() => {});
    },

    methods: {}
};
</script>
<style lang="scss">
.dashboard {
    .card {
        a {
            color: #212529;
            &:hover {
                color: #007bff;
            }
        }
    }
}
</style>
